module.exports = __webpack_public_path__ + "static/business-launch-3ea922bfb7c512ca8a4a52127338f91a.svg";